//import * as GBCXPromo from 'GBCXPromo';
import { Boot } from './States/Boot';
import { Game } from './Game';
import { GameState } from './States/GameState';
import { createEmptySaveData } from './utils/createEmptySaveData';

import languages from 'json/languages.json';

let game: Game;
declare const GBCXPromo;

// @ts-ignore
window.onWrapperReady = () => {
  GBCXPromo.init(
    {
      gameId: 'bubble-shooter-hd-3',
      supportedLanguages: Object.keys(languages),
      placementId_interstitial: '220879418479609_220879695146248',
      placementId_rewarded: '220879418479609_220879895146228',
      resultScreenConfig: {
        showXPromoBanner: false,
        hideButtonsForMs: 2500,
        logoUrl: 'externalImages/game_logo.png',
      },
      // challenge: {
      //   cta: {
      //     en: 'PLAY!',
      //   },
      //   image: {
      //     elements: [
      //       {
      //         url: 'externalImages/msg_poke.jpg',
      //         x: 0,
      //         y: 0,
      //         width: 688,
      //         height: 344,
      //       },
      //       {
      //         url: '%PLAYER_AVATAR%',
      //         x: 261,
      //         y: 87,
      //         width: 176,
      //         height: 176,
      //       },
      //     ],
      //     width: 688,
      //     height: 344,
      //   },
      //   text: {
      //     en: "%USER% just scored %SCORE%",
      //   },
      // },
      // share: {
      //   intent: 'INVITE',
      //   text: {
      //     en: 'Play with me!',
      //   },
      //   image: {
      //     elements: [
      //       {
      //         url: 'externalImages/msg_poke.jpg',
      //         x: 0,
      //         y: 0,
      //         width: 688,
      //         height: 344,
      //       },
      //       {
      //         url: '%PLAYER_AVATAR%',
      //         x: 261,
      //         y: 87,
      //         width: 176,
      //         height: 176,
      //       },
      //     ],
      //     width: 688,
      //     height: 344,
      //   },
      // }
    },
    createEmptySaveData(),
  ).then(() => {
    game = new Game(1250, 900);
    // @ts-ignore
    window.game = game;

    game.state.add(Boot.key, Boot);
    game.state.add(GameState.key, GameState);
    game.state.start(Boot.key);

  });
}

export {
  game,
};
